module.exports = "/_next/static/images/5a3ad8ff8241e773559250e4dab50acd-roxinho-single-lg@3x.jpg";